const initialState = {
  comments: [],
  counts: { entry: 0, byField: {} },
  loading: false,
  error: null,
};

const commentReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'COMMENTS_LOADING':
      return {
        ...state,
        loading: true,
        error: null,
      };
    case 'GET_COMMENTS':
      return {
        ...state,
        comments: action.payload,
        loading: false,
      };
    case 'SET_COMMENT_COUNTS':
      return {
        ...state,
        counts: action.payload,
      };
    case 'COMMENT_ERROR':
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case 'CLEAR_COMMENTS':
      return initialState;
    default:
      return state;
  }
};

export default commentReducer;
